"use client";

import styles from "./MMGallery.module.scss";
import ImageAtom from "@components/atoms/Image";
import { ImageIcon } from "lucide-react";
import CustomLink from "@components/atoms/Link";
import { createVideoSource } from "@utils/videoUtils";
import { DeviceType, VideoMetadata, VideoSource } from "@interfaces/video";
import { useState } from "react";
import VideoModal from "../VideoModal/VideoModal";

interface MMGalleryProps {
  maxVisibleImages?: number;
  brand: string;
  model: string;
  variant?: string;
  galleryMedia: any;
  isMobile: any;
  className?: string;
  browseGalleryHref?: string;
  hidebrowseButton?: boolean;
  cityName?: string;
  carAvailability?: string;
  pageType?: string;
}

export const MMGallery: React.FC<MMGalleryProps> = ({
  brand,
  model,
  variant,
  galleryMedia,
  isMobile,
  className,
  browseGalleryHref = "./images",
  hidebrowseButton = false,
  cityName,
  carAvailability,
  pageType,
}) => {
  // Handle video card click
  const handleVideoClick = (
    url: string,
    metadata: VideoMetadata,
    index?: number
  ) => {
    if (typeof window !== "undefined" && window.innerWidth <= 768) {
      setDeviceType(DeviceType.MOBILE);
    } else {
      setDeviceType(DeviceType.DESKTOP);
    }
    setSelectedVideo(createVideoSource(url));
    setSelectedMetadata(metadata);
    setIsModalOpen(true);
  };

  // Handle modal close
  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedVideo(null);
    setSelectedMetadata(null);
  };
  const [selectedVideo, setSelectedVideo] = useState<VideoSource | null>(null);
  const [selectedMetadata, setSelectedMetadata] =
    useState<VideoMetadata | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deviceType, setDeviceType] = useState<DeviceType>(DeviceType.DESKTOP);

  // Fetch images from the new API
  const images = galleryMedia?.mediaGroups?.IMAGE?.media || [];
  const videos = galleryMedia?.mediaGroups?.VIDEO?.media || [];
  if (images.length === 0 && videos.length === 0) return;
  const totalImages = galleryMedia?.mediaGroups?.IMAGE?.totalCount || 0;
  const visibleImages = images.slice(0, 7);
  
  return (
    <div className={className ? className : styles["mm-gallery__wrapper"]}>
      <div className={styles["mm-gallery"]}>
        <h2 className={styles["mm-gallery__title"]}>
          {`${brand} ${model} gallery`}
          {/* {`${brand} ${model} gallery - images and videos`} */}
        </h2>

        {/* <div className={styles["mm-gallery__header"]}>
          <ImageIcon />

          <p>{`${brand} ${model} images (${totalImages})`}</p>
        </div> */}

        <div className={styles["mm-gallery__images"]}>
          {visibleImages.map((image: any, index: number) => (
            <div
              key={index + image.fileName || image.url || index}
              className={styles["mm-gallery__images__img"]}
            >
              <ImageAtom src={image.url} alt={image.altTag ?? "Image"} fill />

              {index ===
                (galleryMedia?.mediaGroups?.IMAGE?.media?.length -
                  (isMobile ? 2 : 1)) &&
                totalImages > 0 && (
                  <div className={styles["view-all"]}>
                    <span className={styles["view-all__text"]}>
                      <CustomLink
                        href={browseGalleryHref}
                        segmentEventProps={{
                          eventName: "action",
                          pageType: pageType,
                          eventProperties: {
                            action_type: "tap_btn",
                            action_name: "tap_btn_widget_cta",
                            cta_name: "Gallery",
                            car_availability: carAvailability,
                            city_name: cityName,
                            vehicle_make: brand,
                            vehicle_model: model,
                            ...(variant && {vehicle_variant : variant})
                          },
                        }}
                      >
                        View all images
                      </CustomLink>
                    </span>
                  </div>
                )}
            </div>
          ))}
        </div>
      </div>
      {/* {videos.length > 0 && (
        <div className={styles["mm-gallery"]}>
          <div className={styles["mm-gallery__header"]}>
            <ImageAtom
              src={`${assetLoader()}/icons/icon-video.svg`}
              alt="video icon"
              width={24}
              height={24}
            />

            <p>ACKO Drive Shorts</p>
          </div>

          <div className={styles["mm-gallery__shorts"]}>
            {videos.map((video: any, index:number) => (
              <GalleryShortsVideoCard
                key={video.url}
                video={{
                  uri: video.url,
                  thumbnail: video.metadata.thumbnail,
                  title: video.metadata.title,
                }}
                metadata={{
                  title: video.metadata.title,
                  thumbnail: video.metadata.thumbnail,
                  tag: video.metadata.isExclusive ? "Exclusive" : "Acko Drive",
                }}
                onClick={() => handleVideoClick(video?.url, video?.metadata)}

              />
            ))}
          </div>

        </div>
      )} */}

      <VideoModal
        video={selectedVideo}
        metadata={selectedMetadata}
        isOpen={isModalOpen}
        onClose={handleModalClose}
        deviceType={deviceType}
        config={{
          autoplay: true,
          muted: false,
          showTitle: true,
          showProgress: true,
          showVolume: true,
          showClose: true,
        }}
        events={{
          onPlay: () => console.log("Video started playing"),
          onPause: () => console.log("Video paused"),
          onEnded: () => console.log("Video ended"),
          onError: (error) => console.error("Video error:", error),
        }}
      />
    </div>
  );
};
